<section class="sorting-section">
  <!--  <div class="sheet-expander"></div>-->

  <header class="mobile-app-bar">
    <app-icon (click)="close()" iconName="close" size="24px"></app-icon>
    <h2 class="mobile-app-bar__heading" translate>Sort and Filter</h2>
    <p (click)="clearFilters()" class="clear-text" translate>dates&filters.clear</p>
  </header>
  <!-- Instructor Filter -->
  @if (currentTabRoute === 'instructors') {
    <div class="sorting-filters mt-46">
      <div class="tags">
        @if (!loadings.tags) {
          @if (tagsFilter && tagsFilter.length > 0) {
            <ng-select
              (change)="onInstructorFilterChange($event, 'tags')"
              [(ngModel)]="instructorFilters['tags']"
              [closeOnSelect]="false"
              [items]="tagsFilter"
              [multiple]="true"
              [placeholder]="'Tags' | translate"
              [selectOnTab]="true"
              class="custom simple-tags"
              hideSelected="true"
              maxSelectedItems="3"
            ></ng-select>
          }
        } @else {
          <ng-container *ngTemplateOutlet="loader"></ng-container>
        }
      </div>
      <!--  Instructor Type  -->
      <div class="instructor-type">
        <app-dropdown
          (itemSelected)="onInstructorFilterChange($event.instructorType, 'instructorType')"
          [(ngModel)]="instructorFilters['instructorType']"
          [options]="instructorTypeFilterItems"
          [placeholder]="'Type' | translate"
          bindValue="value"
          displayName="key"
          width="100%"
        ></app-dropdown>
      </div>
    </div>
  }
  <!--  <div>-->
  <!--    <app-dropdown *ngIf="currentTabRoute === 'courses'" [options]="[{ label: 'courses.all rooms' | translate, value: 'all_rooms' }]" selectedItem="all_rooms"></app-dropdown>-->
  <!--  </div>-->
  <!-- Rooms Filters -->
  @if (currentTabRoute === 'rooms') {
    <div class="sorting-filters mt-46">
      <div class="tags">
        @if (!loadings.tags) {
          @if (tagsFilter && tagsFilter.length > 0) {
            <ng-select
              (change)="onRoomFilterChange($event, 'tags')"
              [(ngModel)]="roomFilters['tags']"
              [closeOnSelect]="false"
              [items]="tagsFilter"
              [multiple]="true"
              [placeholder]="'Tags' | translate"
              [selectOnTab]="true"
              class="custom simple-tags"
              hideSelected="true"
              maxSelectedItems="3"
            ></ng-select>
          }
        } @else {
          <ng-container *ngTemplateOutlet="loader"></ng-container>
        }
      </div>
      <!--   Room Type   -->
      <div class="room-type">
        <app-dropdown
          (itemSelected)="onRoomFilterChange($event.roomType, 'instructorType')"
          [(ngModel)]="roomFilters['instructorType']"
          [options]="roomTypeFilterItems"
          [placeholder]="'Type' | translate"
          bindValue="value"
          displayName="key"
          width="100%"
        ></app-dropdown>
      </div>
    </div>
  }

  <!-- Courses Filters -->
  @if (currentTabRoute === 'courses') {
    <div class="sorting-filters mt-46">
      <div class="tags">
        @if (!loadings.tags) {
          @if (tagsFilter && tagsFilter.length > 0) {
            <ng-select
              (change)="onCourseFilterChange($event, 'tags')"
              [(ngModel)]="courseFilter['tags']"
              [closeOnSelect]="false"
              [items]="tagsFilter"
              [multiple]="true"
              [placeholder]="'Tags' | translate"
              [selectOnTab]="true"
              class="custom simple-tags"
              hideSelected="true"
              maxSelectedItems="3"
            ></ng-select>
          }
        } @else {
          <ng-container *ngTemplateOutlet="loader"></ng-container>
        }
      </div>
      <!--   Room Type   -->
      <div class="room-type">
        @if (!loadings.rooms) {
          @if (roomsFilter && roomsFilter.length > 0) {
            <ng-select
              (change)="onCourseFilterChange($event, 'room')"
              [(ngModel)]="courseFilter['room']"
              [closeOnSelect]="false"
              [items]="roomsFilter"
              [multiple]="true"
              [placeholder]="'courses.rooms' | translate"
              [selectOnTab]="true"
              bindLabel="name"
              class="custom simple-tags"
              hideSelected="true"
              maxSelectedItems="3"
            ></ng-select>
          }
        } @else {
          <ng-container *ngTemplateOutlet="loader"></ng-container>
        }
      </div>
      <!--  Courses Type  -->
      <div class="room-type">
        <app-dropdown
          (itemSelected)="onCourseFilterChange($event.courseType, 'instructorType')"
          [(ngModel)]="courseFilter['instructorType']"
          [options]="courseTypeFilterItems"
          [placeholder]="'Type' | translate"
          bindValue="value"
          displayName="key"
          width="100%"
        ></app-dropdown>
      </div>
    </div>
  }

  <!--  Apply button -->
  <div>
    <button (click)="applyFilters()" class="button button-medium button-primary button-full mt-30" translate>Apply Filter</button>
  </div>
</section>

<ng-template #loader>
  <ngx-skeleton-loader
    [theme]="{
      height: '30px',
    }"
    count="1"
  ></ngx-skeleton-loader>
</ng-template>
